// Shell público v2 — topbar con logo + área centrada (card o contenido
// libre) + footer con copyright/términos/privacidad/mail.
//
// Lo usan todas las páginas v2 fuera del dashboard:
//   - Auth: login, register, reset-password, forgot-password, onboarding,
//     account-suspended.
//   - Marketing: demo, plans, privacy, terms.
//
// Diseño exacto del handoff "Talenv Login Centered.html":
//   - Fondo crema (#FAF7F2) con 2 halos radiales (violeta arriba, lima abajo der.)
//   - Plus Jakarta Sans para display + Inter para body
//   - Card centrado (max 420px), border radius 16, sombras suaves
//
// La página puede pasar `card={false}` para layouts más anchos (plans,
// privacy, terms) y manejar el contenido a mano.
//
// IMPORTANTE: el CSS base de `.v2shell-root` (clases topbar/card/btn/etc)
// vive en `app/globals.css` para evitar FOUC durante el primer paint en
// hard-reload. Acá solo aplicamos `maxWidth` dinámico inline.

import Link from "next/link";
import { BrandMark } from "@/components/brand/BrandMark";

export function PublicShell({
  locale,
  children,
  card = true,
  maxWidth = 420,
}: {
  locale: string;
  children: React.ReactNode;
  /** Si false, no envuelve children en .shell-card — útil para layouts con
   *  varias columnas (pricing, legal). Default true. */
  card?: boolean;
  /** Ancho del card. Default 420. */
  maxWidth?: number;
}) {
  return (
    <div className="v2shell-root">
      <header className="topbar">
        <Link href={`/${locale}`} className="logo">
          <BrandMark size={28} rounded={8} />
          talenv
        </Link>
      </header>

      <main className={`center-wrap ${card ? "" : "top"}`}>
        {card ? (
          <div className="shell-card" style={{ maxWidth }}>{children}</div>
        ) : (
          <div className="shell-wide" style={{ maxWidth }}>{children}</div>
        )}
      </main>

      <footer className="page-foot">
        <span>© {new Date().getFullYear()} Talenv</span>
        <span className="sep">·</span>
        <Link href={`/${locale}/terms`}>Términos</Link>
        <Link href={`/${locale}/privacy`}>Privacidad</Link>
        <a href="mailto:hola@talenv.com">hola@talenv.com</a>
      </footer>
    </div>
  );
}
